export { default as ModalitiesModal } from './ModalitiesModal';
